import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from 'react-router-dom';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import { FooterText } from './FooterText';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';

import Work from '@material-ui/icons/Work';
import CalendarToday from '@material-ui/icons/CalendarToday';
import LocalOffer from '@material-ui/icons/LocalOffer';
import Chat from '@material-ui/icons/Chat';

import footerStyle from 'assets/jss/material-dashboard-pro-react/components/footerStyle';
import compose from 'recompose/compose';
import { connect } from 'react-redux';

import { pushChat } from 'store/actions/navigationActions';

function Footer({ ...props }) {
  const { classes, fluid, white, rtlActive, pushChat, uid, path } = props;
  console.log(path)
  var container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white,
  });
  var anchor =
    classes.a +
    cx({
      [' ' + classes.whiteColor]: white,
    });

  return (
    <footer className={classes.footer} style={path.includes('threads') ? { visibility: 'hidden' } : { width: '100%' }}>
      <div className={container}>
        <div
          className={classes.right}
          style={{ textAlign: 'center', width: '100%', padding: '5px' }}
        >
          <GridContainer style={{ marginTop: '15px' }}>
            <GridItem xs={3}>
              <Link
                to={{
                  pathname: `/cases`,
                }}
              >
                <Work style={{ color: '#bbb' }} />
              </Link>
            </GridItem>
            <GridItem xs={3}>
              <Link
                to={{
                  pathname: `/calendar`,
                }}
              >
                <CalendarToday style={{ color: '#bbb' }} />
              </Link>
            </GridItem>
            <GridItem xs={3}>
              <Link
                to={{
                  pathname: `/offers`,
                }}
              >
                <LocalOffer style={{ color: '#bbb' }} />
              </Link>
            </GridItem>
            <GridItem xs={3}>
              <Link to={{ pathname: '/chat' }}>
                <Chat style={{ color: '#bbb' }} />
              </Link>
            </GridItem>
          </GridContainer>
          <FooterText anchor={anchor} rtlActive={rtlActive} />
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool,
};

const mapStateToProps = (state) => {
  // console.log('footerstate', state)
  return {
    uid: state.user.user.id,
    path: state.router.location.pathname
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(footerStyle)
)(Footer);
